document.addEventListener("DOMContentLoaded", function () {
	infiniteScrollCollection();
});

function infiniteScrollCollection() {
	var endlessScroll = new Ajaxinate({
		container: '#AjaxBlogContainer',
		pagination: '#AjaxBlogPagination',
		loadingText: 'Ver más editoriales...',
		method: "scroll",
		offset: 1000,
	});
}

if (!window.jQuery) {
	var jqueryScript = document.createElement("script");
	jqueryScript.setAttribute("src", "https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js");
	document.head.appendChild(jqueryScript);
}

var jQueryinterval = setInterval(function () {
	// wait for jQuery to load & run script after jQuery has loaded
	if (window.jQuery && SnapbackCache) {
		var snapbackCache = SnapbackCache({
			bodySelector: "#product-grid",
		});

		jQuery(document).on("click", "#product-grid .card-wrapper", function (e) {
			snapbackCache.cachePage();
		});

		jQuery(document).on("snapback-cache:loaded", function (e, cachedPage) {
			infiniteScrollCollection();
			window.scrollTo(0, cachedPage.positionY);
		});

		$(window).bind("beforeunload", function () {
			snapbackCache.cachePage();
		});
	}

	clearInterval(jQueryinterval);
}, 500);
